import React from 'react';
import { useNavigate } from 'react-router-dom';
import './PageAccueil.scss';
import imageAccueil from '../assets/images/photo-accueil.jpg';
import imageMobile from '../assets/images/image-accueil-mobile.jpg';

const PageAccueil = function PageAccueil() {
  const navigate = useNavigate();

  return (
    <div className="accueil">
      <img className="photoaccueil" src={imageAccueil} alt="accueil" />
      <img className="photomobile" src={imageMobile} alt="accueilmobile" />
      <div className="allomano">
        <h1 className="titreaccueil">
          AlloMano ? <br /> I need help !
        </h1>
        <button
          className="entreeaccueil"
          type="submit"
          onClick={() => navigate('/allomano')}
        >
          Enter
        </button>
      </div>
      <div className="allomano2">
        <h1 className="titreaccueil2">
          AllaMano ? <br /> Do it !
        </h1>
        <button
          className="entreeaccueil2"
          type="submit"
          onClick={() => navigate('/allamano')}
        >
          Enter
        </button>
      </div>
    </div>
  );
};

export default PageAccueil;
